import React from 'react'

const NoImg = props => (
	<img src="/images/no-image.png" alt="" loading="lazy" {...props} />
)

export default NoImg
